import { getBoundsOfDistance as getBoundsOfDistanceGeolib } from 'geolib';
import { types as sdkTypes } from '@nomady/shared/utils/sdkLoader';
const { LatLngBounds, LatLng } = sdkTypes;
export const getBoundsOfDistance = (latlng, distance) => {
    const bounds = getBoundsOfDistanceGeolib({ latitude: latlng.lat, longitude: latlng.lng }, distance);
    return new LatLngBounds(new LatLng(bounds[1].latitude, bounds[1].longitude), new LatLng(bounds[0].latitude, bounds[0].longitude));
};
